import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41142e73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "super-view-class" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "kehucontainer" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "bottomDownload"
}
const _hoisted_7 = { class: "leftcon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "titleCon" }
const _hoisted_10 = { style: {"font-size":"15px","font-weight":"bold"} }
const _hoisted_11 = { style: {"font-size":"10px"} }
const _hoisted_12 = { class: "rightcon" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "maskClass"
}
const _hoisted_15 = { class: "centerViewClass" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { style: {"color":"white","font-size":"18px","font-weight":"600"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_drag = _resolveDirective("drag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <Loading :loading=\"loading\" />\n    <van-pull-refresh v-model=\"loadingsta\" @refresh=\"onRefresh\">\n      <Swiper ref=\"Swipers\" @getalldata=\"editConfirm\" />\n      <Populartoday ref=\"Populartodays\" @getalldata=\"editConfirm\" @tabscr=\"tabscr\" />\n    </van-pull-refresh> "),
      _createVNode($setup["Swiper"]),
      _createVNode($setup["Populartoday"], {
        ref: "Populartodays",
        onGetalldata: $setup.editConfirm,
        onTabscr: $setup.tabscr
      }, null, 512 /* NEED_PATCH */),
      _createCommentVNode(" 增加产品介绍 "),
      _createElementVNode("div", {
        class: "product-html-class",
        innerHTML: $setup.htmlInfo
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createCommentVNode(" <transition name=\"slide-fade\" mode=\"out-in\" v-if=\"th != 'th'\">\n                      <div class=\"rightBottomBox\" v-show=\"showAnimation\">\n                        <img @click=\"nativeToNewWeb(router, '/activity?a=1')\" :src=\"pos1\" alt=\"\">\n                        <img @click=\"nativeToNewWeb(router, '/invitef?a=1')\" :src=\"pos2\" alt=\"\">\n                      </div>\n                    </transition> "),
    _withDirectives(_createElementVNode("div", {
      class: "rightBottomBox",
      style: _normalizeStyle({ bottom: $setup.Platform.client == 'ios' ? '80px' : '120px' })
    }, [
      _createCommentVNode(" <div v-show=\"showFuli\" v-drag\n      :style=\"{ left: screen.clientWidth - 53 + 'px', top: screen.clientHeight - 265 + 'px', position: 'fixed' }\">\n      <img class=\"downBox2\" @click=\"toActivity\" :src=\"pos1\" alt=\"\">\n      <img class=\"close\" :src=\"close_icon\" @click=\"showFuli = false\">\n    </div>\n    <div v-show=\"showInvite\" v-drag\n      :style=\"{ left: screen.clientWidth - 53 + 'px', top: screen.clientHeight - 190 + 'px', position: 'fixed' }\">\n      <img class=\"downBox2\" @click=\"toInvite\" :src=\"pos2\" alt=\"\">\n      <img class=\"close\" :src=\"close_icon\" @click=\"showInvite = false\">\n    </div> ")
    ], 4 /* STYLE */), [
      [_vShow, $setup.is_has_history]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({ left: $setup.screen.clientWidth - 70 + 'px', top: $setup.screen.clientHeight / 2 + 'px', position: 'fixed' })
      }, [
        _createElementVNode("img", {
          class: "kehuIcon",
          src: $setup.kehu_icon,
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onKehuClick()))
        }, null, 8 /* PROPS */, _hoisted_4),
        _createElementVNode("img", {
          class: "play_off_btn",
          src: $setup.play_off_btn,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showKehu = false))
        }, null, 8 /* PROPS */, _hoisted_5)
      ], 4 /* STYLE */)), [
        [_vShow, true],
        [_directive_drag]
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.showKehu]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "jumpNowDay",
      onClick: $setup.jumpTopFn
    }, _toDisplayString(_ctx.$t('home.jumpTop')), 513 /* TEXT, NEED_PATCH */), [
      [_vShow, $setup.jumpTop]
    ]),
    ($setup.showDownApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", { src: $setup.downLogo }, null, 8 /* PROPS */, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('home.qwzk')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('home.lggg')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "btn",
              style: _normalizeStyle({ backgroundColor: $setup.activeColor, color: $setup.activeFontColor }),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toDownloadApp()))
            }, _toDisplayString(_ctx.$t('home.downapp')), 5 /* TEXT, STYLE */),
            _createElementVNode("img", {
              class: "close",
              src: $setup.close_icon,
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showDownApp = false))
            }, null, 8 /* PROPS */, _hoisted_13)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.showActiveAlertView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: $setup.activeObj.cover
            }, null, 8 /* PROPS */, _hoisted_16),
            _createElementVNode("img", {
              src: $setup.activeCloseIcon,
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.closeActive()))
            }, null, 8 /* PROPS */, _hoisted_17)
          ]),
          _createVNode(_component_van_button, {
            style: {"margin-top":"24px","width":"160px","height":"45px","border-style":"none","background":"linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1))"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.onActivityClick($setup.activeObj))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('立即参与')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}